<template>
<div>
  <div class="h-100 w-100 track-item flex">
    <div class="pointer h-100 w-95">
      <p class="title fl w-30 h-100 pa1 pl3 ma0 text-ellipsis center-content textColor lh item-mobile-track">{{ purchase.track.title }}</p>
      <router-link :to="{ name:'artist-info', params:{ id:purchase.track.artist.id }}" append @click.native.stop class="textColor no-underline">
        <p class="artist fl w-20 h-100 pa1 pl3 ma0 text-ellipsis center-content textColor lh item-mobile-artist">{{ purchase.track.artist.name }}</p>
      </router-link>
      <p class="released fl w-15 h-100 pa1 pl3 ma0 center-content textColor lh item-not-mobile">{{ this.trackTime }}</p>
      <p class="title fl w-21 h-100 pa1 pl3 ma0 text-ellipsis center-content textColor lh item-not-mobile">{{ this.payment_date }}</p>
      <a id="db" class="db-mobile" @click="download()" :href=download_url>
          Descargar
      </a>
    </div>
  </div>
</div>
</template>

<script>
  import consts from '@/consts'
  export default {
    name: 'track-download-item-list',
    props: {
      purchase: {
        required: true
      }
    },
    data () {
      return {
        trackTime: null,
        download_url: null,
        payment_date: null
      }
    },
    components: {
    },
    created () {
      this.download_url = consts.API_BASE_URL + '/tracks/download/' + this.purchase.hash.hash
    },
    computed: {
    },
    methods: {
      trackTimeToMin () {
        let seg = this.purchase.track.seconds
        let min = 0
        this.trackTime = 0
        for (let i = 0; i < 60; i++) {
          if (seg > 60) {
            min++
            seg -= 60
          } else if (seg < 60) {
            if (seg <= 9) {
              this.trackTime = (`${min}:0${seg}`)
              return this.trackTime
            } else {
              this.trackTime = (`${min}:${seg}`)
              return this.trackTime
            }
          }
        }
      },
      formatPaymentDate () {
        let d = (this.purchase.payment.date).split('T')
        this.payment_date = d[0].split('-').reverse().join('-')
      }
    },
    mounted () {
      this.trackTimeToMin()
      this.formatPaymentDate()
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  .center-content {
    line-height: normal;
  }

  .play-pause-icon {
    margin-left: 10px;
  }

  .track-card {
    display: none;
  }

  .image-container {
    width: 48px;
    height: 48px;
    min-width: 48px;
    min-height: 48px;
  }

  .w-21 {
    width: 21%;
  }

  .lh {
    line-height: 38px;
  }

  #db {
    border-radius: 36px 36px 36px 36px;
    outline: 0;
    border-width: 1px;
    border-color: #E6007E;
    background-color: #E6007E;
    color: #fff;
    outline-offset: 1px;
    overflow: hidden;
    padding: 3px 25px;
    font-weight: bold;
    text-decoration: none;
    line-height: 47px;
  }

  #db:hover{
    background-color: #fff !important;
    color: #E6007E !important;
  }

  @media (max-width: 768px) {
    /*
    .track-card {
      display: flex;
    }

    .track-item {
      display: none;
    }
    */
    .item-not-mobile {
      display: none;
    }
    .item-mobile-track {
      width: 107px;
    }
    .item-mobile-artist {
      width: 77px;
    }

    .db-mobile {
      padding: 2px 6px !important;
      margin-left: 25px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/tracks/TrackDownloadItemList.vue